import React from 'react'
import { MenuOutlined } from '@ant-design/icons'

export default [
  {
    className: 'drag-visible',
    dataIndex: 'sort',
    key: 'order',
    render: (text, record, index) => (
      <a
        className='drag-handle'
        href='#'
      >
        <MenuOutlined
          style={{
            color: '#999',
            cursor: 'grab'
          }}
        />
      </a>),
    title: 'Sort',
    width: 30
  },
  {
    dataIndex: 'name',
    key: 'name',
    title: 'Name',
    width: 300
  }
]
